import { lightningChart, type LightningChart } from "@lightningchart/lcjs";

let lcjs: LightningChart;

export const useUseLightningCharts = () => {
  if (!lcjs) {
    const { public: { lcjsKey } } = useRuntimeConfig();
    lcjs = lightningChart({ license: lcjsKey });
  }

  return lcjs;
}
